// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"b60b052e","909":"21317df3"}[chunkId] + ".chunk.css";
};